import React, { ReactNode } from "react";

import useDebouncedCallback from "@mapmycustomers/shared/util/hook/useDebouncedCallback";
import { SearchField } from "@mapmycustomers/ui";

import styles from "./RecordListSearch.module.scss";

interface Props {
  actions?: ReactNode;
  onSearch: (query: string) => void;
  placeholder?: string;
}

const RecordListSearch = ({ actions, onSearch, placeholder }: Props) => {
  const handleChange = useDebouncedCallback([onSearch, 500, { trailing: true }], [onSearch]);

  return (
    <div className={styles.container}>
      <SearchField
        allowClear
        className={styles.search}
        onChange={handleChange}
        placeholder={placeholder}
        size="middle"
      />
      {actions && <div>{actions}</div>}
    </div>
  );
};

export default RecordListSearch;
